import { render, staticRenderFns } from "./SetPasswordUserDialog.vue?vue&type=template&id=b9515360&scoped=true&"
import script from "./SetPasswordUserDialog.vue?vue&type=script&lang=ts&"
export * from "./SetPasswordUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9515360",
  null
  
)

export default component.exports